/* AMES — Motore di ricerca del sito.
 *
 * Perche' esiste. La ricerca di Shopify pesca anche nelle descrizioni e non
 * sa quale parola del titolo e' l'oggetto: "prolunga elettrica" dava gruppi
 * elettrogeni e scovolini, "trapano" metteva in testa un set di punte,
 * "tuta da lavoro" un cappello di paglia. Qui l'ordine lo decidiamo noi.
 *
 * Come ragiona. I titoli del catalogo cominciano con l'oggetto ("Trapano a
 * percussione M18 Milwaukee"), quindi la prima parola pesa piu' delle altre,
 * e quello che viene dopo "per" e' lo scopo di un accessorio ("Punta per
 * trapano"), non l'oggetto. Ogni parola di ogni prodotto ha gia' un punteggio
 * 1-25 calcolato all'indice (md_ingest/ricerca/costruisci_motore.js):
 * posizione nel titolo, categoria, marchio, codici, etichette. Qui si legge la
 * domanda, si capisce qual e' l'oggetto (la prima parola che non e' marchio,
 * misura o modello), si sommano i punteggi e si ordina: prima chi ha
 * l'oggetto nel titolo o nella categoria, poi chi ha piu' parole della
 * domanda, poi il punteggio. Accessori e prodotti collegati vengono dopo.
 *
 * File (in assets/, generati dall'indice):
 *   ames-mx-<lingua>.json       manifesto: versione, mappa parola -> file, marchi, categorie tradotte
 *   ames-mx-<lingua>-NNN.json   parole -> elenco prodotti con punteggio
 *   ames-mx-a.json              categoria e marchio di ogni prodotto (a tratti, i prodotti sono in ordine di categoria)
 *   ames-mx-h-NNN.json          handle dei prodotti, 512 per file
 *
 * La stessa funzione tokenizza() serve all'indice (Node) e alla domanda
 * (browser): parole, misure e radici escono identiche dalle due parti.
 */
(function (root) {
  'use strict';

  function insieme(s) {
    var o = {};
    s.split(' ').forEach(function (w) { if (w) o[w] = 1; });
    return o;
  }

  /* Parole vuote: non si indicizzano e non si cercano. */
  var VUOTE = {
    it: insieme('a ad al allo alla ai agli alle all dell nell dall sull con col coi da dal dallo dalla dai dagli dalle de del dello della dei degli delle di d e ed il in la le lo l gli i nel nello nella nei negli nelle un una uno o od su sul sullo sulla sui sugli sulle tra fra per che x'),
    en: insieme('a an the of for with and or to in on by from at as its x'),
    es: insieme('el la los las un una unos unas de del al y e o u para con por en a lo x'),
    pl: insieme('i w z ze do na od dla o a oraz lub we po x'),
    ar: insieme('و في من على الى عن مع او ل ب')
  };
  /* Parole della domanda che non descrivono il prodotto ("cerco un trapano"). */
  var DISCORSO = {
    it: insieme('cerco cercare cercando vorrei voglio serve servono servirebbe mi ci devo dovrei posso come cosa quale quali dove comprare acquistare prezzo prezzi costo costi offerta offerte economico economica economici economiche migliore migliori qualcosa'),
    en: insieme('need want buy best cheap price prices looking search find something'),
    es: insieme('busco quiero necesito comprar precio precios barato barata mejor algo'),
    pl: insieme('szukam potrzebuje kupic cena ceny tani tania najlepszy cos'),
    ar: insieme('اريد ابحث شراء سعر افضل')
  };
  /* Parole generiche della domanda ("attrezzatura idraulico", "utensili
     muratore"): si tolgono quando resta altro. */
  var GENERICI_Q = {
    it: insieme('attrezzatura attrezzature attrezzi attrezzo utensili utensile strumenti strumento materiale materiali prodotti prodotto articoli articolo forniture fornitura occorrente dotazione dotazioni equipaggiamento dpi'),
    en: insieme('tools tool equipment supplies products product gear kit'),
    es: insieme('herramientas herramienta equipo equipos equipamiento productos producto material materiales'),
    pl: insieme('narzedzia narzedzie sprzet produkty produkt wyposazenie'),
    ar: insieme('ادوات معدات منتجات')
  };
  /* Verbo all'infinito in testa a una frase ("devo tagliare piastrelle",
     "proteggere le orecchie dal rumore"): domanda in linguaggio naturale. */
  var ATTACCHI = insieme('devo dobbiamo devi deve posso possiamo voglio vorrei per come cosa serve servono bisogna occorre da di a');
  var NON_VERBI = insieme('cantiere polvere mestiere tagliere bicchiere braciere paniere carattere quartiere sparviere cavaliere potere piacere sedere solare circolare lineare modulare tubolare collare angolare lamellare cellulare polare molare regolare particolare');

  /* Dopo queste parole il titolo dice a cosa serve l'oggetto (zona 2)... */
  var SCOPO = { it: insieme('per'), en: insieme('for'), es: insieme('para'), pl: insieme('do dla'), ar: {} };
  /* ...dopo queste, cosa c'e' insieme (zona 1). */
  var INSIEME = { it: insieme('con'), en: insieme('with'), es: insieme('con'), pl: insieme('z ze'), ar: insieme('مع') };
  /* Prime parole che non sono l'oggetto: "Set punte...", "Mini smerigliatrice". */
  var GENERICI = {
    it: insieme('kit set mini micro maxi super nuov confezion conf copp seri pacc pack assortiment combo blister'),
    en: insieme('kit set mini micro maxi super new pack pair combo'),
    es: insieme('kit set mini micro maxi super nuev juego pack par combo'),
    pl: insieme('zestaw komplet mini mikro maxi super nowy pakiet para'),
    ar: insieme('طقم مجموعه')
  };
  /* Generici che indicano una confezione di piu' oggetti. */
  var CONFEZIONI = insieme('kit set confezion conf copp pacc pack assortiment combo blister juego zestaw komplet pakiet pair par طقم مجموعه');

  /* Unita' di misura dopo un numero: "18 V" -> 18v, "50 litri" -> 50l. */
  var UNITA = {
    mm: 'mm', cm: 'cm', mt: 'm', m: 'm', metri: 'm', km: 'km', kw: 'kw', kilowatt: 'kw',
    w: 'w', watt: 'w', kv: 'kv', kva: 'kva', v: 'v', volt: 'v', kg: 'kg', g: 'g', gr: 'g',
    grammi: 'g', lt: 'l', l: 'l', litri: 'l', litro: 'l', ml: 'ml', cl: 'cl', ah: 'ah',
    mah: 'mah', bar: 'bar', psi: 'psi', nm: 'nm', hp: 'hp', cv: 'hp', j: 'j', joule: 'j',
    ampere: 'a', amp: 'a', mq: 'm2', m2: 'm2', m3: 'm3', mc: 'm3', hz: 'hz', rpm: 'rpm',
    lm: 'lm', lumen: 'lm', db: 'db', t: 't', ton: 't', tonnellate: 't', kn: 'kn', mpa: 'mpa',
    pollici: 'in', inch: 'in'
  };
  /* Unita' che staccate dal numero sono anche parole della lingua ("2 w zestawie"). */
  var AMBIGUE = { pl: { w: 1 }, it: {}, en: {}, es: {}, ar: {} };
  var CANONICHE = {};
  Object.keys(UNITA).forEach(function (k) { CANONICHE[UNITA[k]] = 1; });
  var RX_MIS = new RegExp('(\\d+(?:\\.\\d+)?)(\\s*)(' +
    Object.keys(UNITA).sort(function (a, b) { return b.length - a.length; }).join('|') +
    ')(?![a-z0-9])', 'g');

  /* Coppie maschile/femminile che la radice confonderebbe (pala/palo, cavo/cava). */
  var ECCEZIONI_IT = {
    pala: 'pala', pale: 'pala', palo: 'palo', pali: 'palo', porta: 'porta', porte: 'porta',
    porto: 'porto', porti: 'porto', colla: 'colla', colle: 'colla', collo: 'collo', colli: 'collo',
    mola: 'mola', mole: 'mola', molo: 'molo', moli: 'molo', tela: 'tela', tele: 'tela',
    telo: 'telo', teli: 'telo', cassa: 'cassa', casse: 'cassa', cavo: 'cavo', cavi: 'cavo',
    cava: 'cava', cave: 'cava', secchio: 'secchio', secchi: 'secchio', secca: 'secc', secco: 'secc',
    mazza: 'mazza', mazze: 'mazza', mazzo: 'mazzo', mazzi: 'mazzo', manica: 'manica',
    maniche: 'manica', manico: 'manico', manici: 'manico', busto: 'busto', busti: 'busto',
    fascia: 'fascia', fasce: 'fascia', fascio: 'fascio', fasci: 'fascio', filo: 'filo', fili: 'filo',
    punto: 'punto', punti: 'punto'
  };

  function base(s) {
    s = String(s == null ? '' : s).toLowerCase();
    s = s.replace(/½/g, ' 1/2 ').replace(/¼/g, ' 1/4 ').replace(/¾/g, ' 3/4 ');
    s = s.replace(/ł/g, 'l').replace(/ß/g, 'ss').replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/œ/g, 'oe');
    if (s.normalize) s = s.normalize('NFD');
    s = s.replace(/[̀-ͯ]/g, '');
    s = s.replace(/[ً-ٰٟـ]/g, '').replace(/[إأآ]/g, 'ا').replace(/ى/g, 'ي').replace(/ة/g, 'ه');
    s = s.replace(/[×✕]/g, 'x').replace(/[’`´]/g, "'");
    return s;
  }

  function numero(n) {
    if (n.indexOf('.') < 0) return n;
    n = n.replace(/0+$/, '');
    return n.charAt(n.length - 1) === '.' ? n.slice(0, -1) : n;
  }

  function radice(L, w) {
    if (L === 'it') {
      if (ECCEZIONI_IT[w]) return ECCEZIONI_IT[w];
      if (w.length <= 3) return w;
      var r = w;
      if (/io$/.test(r)) r = r.slice(0, -1);
      if (/[cg]h[ie]$/.test(r)) r = r.slice(0, -2);
      else if (/[aeiou]$/.test(r)) r = r.slice(0, -1);
      return r.length >= 3 ? r : w;
    }
    if (L === 'en') {
      if (w.length <= 3) return w;
      if (/ies$/.test(w) && w.length > 4) return w.slice(0, -3) + 'y';
      if (/(ss|us|is)$/.test(w)) return w;
      if (/(sh|ch|x|z|s)es$/.test(w)) return w.slice(0, -2);
      if (/s$/.test(w)) return w.slice(0, -1);
      return w;
    }
    if (L === 'es') {
      if (w.length <= 3) return w;
      var e = w;
      if (/ces$/.test(e)) e = e.slice(0, -3) + 'z';
      else if (/[^aeiou]es$/.test(e)) e = e.slice(0, -2);
      else if (/s$/.test(e)) e = e.slice(0, -1);
      if (e.length > 4 && /[aeo]$/.test(e)) e = e.slice(0, -1);
      return e.length >= 3 ? e : w;
    }
    if (L === 'pl') {
      var suff = ['ami', 'ach', 'owi', 'ow', 'om', 'em', 'ie', 'y', 'i', 'e', 'a', 'u', 'o'];
      for (var i = 0; i < suff.length; i++) {
        var sx = suff[i];
        if (w.length - sx.length >= 4 && w.slice(-sx.length) === sx) return w.slice(0, -sx.length);
      }
      return w;
    }
    if (L === 'ar') {
      var a = w, pre = ['وال', 'بال', 'كال', 'فال', 'لل', 'ال'];
      for (var j = 0; j < pre.length; j++) {
        if (a.indexOf(pre[j]) === 0 && a.length - pre[j].length >= 3) { a = a.slice(pre[j].length); break; }
      }
      if (a.charAt(0) === 'و' && a.length > 3) a = a.slice(1);
      var suf = ['ات', 'ون', 'ين', 'ه'];
      for (var k = 0; k < suf.length; k++) {
        if (a.length - suf[k].length >= 3 && a.slice(-suf[k].length) === suf[k]) { a = a.slice(0, -suf[k].length); break; }
      }
      return a;
    }
    return w;
  }

  /* Che cosa e' una parola: misura, dimensione, numero, modello o parola. */
  function genere(w) {
    if (/^\d/.test(w)) {
      if (/^\d+(\.\d+)?(x\d+(\.\d+)?)+[a-z0-9]*$/.test(w)) return 'dim';
      if (/^\d+f\d+$/.test(w)) return 'fra';
      if (/^\d+(\.\d+)?$/.test(w)) return w.length >= 5 ? 'cod' : 'num';
      var m = /^\d+(?:\.\d+)?([a-z]+\d?)$/.exec(w);
      if (m && CANONICHE[m[1]]) return 'mis';
      return 'mod';
    }
    if (/\d/.test(w)) return 'mod';
    return 'par';
  }

  /* Testo pronto da spezzare: separatori, frazioni, dimensioni, misure. */
  function prepara(L, s) {
    s = base(s);
    if (L === 'en') {
      s = s.replace(/(\d),(\d{3})(?!\d)/g, '$1$2').replace(/(\d),(\d{3})(?!\d)/g, '$1$2');
    } else {
      s = s.replace(/(\d)\.(\d{3})(?![\d.,])/g, '$1$2');
      s = s.replace(/(\d),(\d)/g, '$1.$2');
    }
    s = s.replace(/(\d{1,2})\s*\/\s*(2|4|8|16|32|64)(?!\d)/g, '$1f$2');
    s = s.replace(/\d+\.\d+/g, numero);
    s = s.replace(/(\d)\s*[x*]\s*(?=\d)/g, '$1x');
    s = s.replace(RX_MIS, function (m, num, sp, u) {
      if (sp && AMBIGUE[L] && AMBIGUE[L][u]) return m;
      return numero(num) + UNITA[u];
    });
    return s;
  }

  /* Il testo diventa un elenco di parole con posizione (p), zona (z: 0 oggetto
     e caratteristiche, 1 dopo "con", 2 dopo "per"), segmento (g: pezzo fra
     virgole), genere (k) e radice (t). Con domanda=true toglie anche le parole
     del discorso ("cerco", "prezzo"). Con indice=true aggiunge le varianti
     (numero nudo delle misure, prefissi delle dimensioni, parole col trattino
     unite) marcate x=1. */
  function tokenizza(L, testo, opz) {
    opz = opz || {};
    if (!VUOTE[L]) L = 'it';
    var s = prepara(L, testo);
    var out = [], p = 0, z = 0;
    var vuote = VUOTE[L], discorso = DISCORSO[L], scopo = SCOPO[L], ins = INSIEME[L];
    var pezzi = s.split(/[,;:()\[\]|\/]+/);
    for (var g = 0; g < pezzi.length; g++) {
      var parti = pezzi[g].split(/[^a-z0-9؀-ۿ.\-]+/);
      for (var i = 0; i < parti.length; i++) {
        var pt = parti[i].replace(/^[.\-]+|[.\-]+$/g, '');
        if (!pt) continue;
        var sotto = pt.split(/-+/);
        var unite = sotto.length > 1 && sotto.every(function (x) { return /^[a-z؀-ۿ]{2,}$/.test(x); });
        var primo = -1;
        for (var j = 0; j < sotto.length; j++) {
          var sp = sotto[j];
          if (!sp) continue;
          var pezzetti = /^\d+(\.\d+)?(x\d+(\.\d+)?)*[a-z0-9]*$/.test(sp) ? [sp] : sp.split('.');
          for (var q = 0; q < pezzetti.length; q++) {
            var w = pezzetti[q];
            if (!w) continue;
            if (scopo[w]) { z = 2; continue; }
            if (ins[w]) { if (z < 1) z = 1; continue; }
            if (vuote[w]) continue;
            if (opz.domanda && discorso[w]) continue;
            var k = genere(w);
            var t = k === 'par' ? radice(L, w) : w;
            if (primo < 0) primo = out.length;
            if (opz.indice && k === 'num' && out.length) {
              var prec = out[out.length - 1];
              if (!prec.x && prec.p === p - 1 && prec.k === 'par' && prec.w.length <= 2) out.push({ t: prec.w + w, w: prec.w + w, k: 'mod', p: p, z: z, g: g, x: 1 });
            }
            out.push({ t: t, w: w, k: k, p: p, z: z, g: g });
            if (opz.indice) {
              if (k === 'mis') {
                var nudo = /^(\d+(?:\.\d+)?)/.exec(w)[1];
                out.push({ t: nudo, w: nudo, k: 'num', p: p, z: z, g: g, x: 1 });
              } else if (k === 'dim') {
                var un = (/[a-z]+\d?$/.exec(w) || [''])[0];
                var dd = w.replace(/[a-z]+\d?$/, '').split('x');
                out.push({ t: dd[0], w: dd[0], k: 'num', p: p, z: z, g: g, x: 1 });
                if (un && CANONICHE[un]) out.push({ t: dd[0] + un, w: dd[0] + un, k: 'mis', p: p, z: z, g: g, x: 1 });
                for (var n = 2; n < dd.length; n++) {
                  var pre = dd.slice(0, n).join('x');
                  out.push({ t: pre, w: pre, k: 'dim', p: p, z: z, g: g, x: 1 });
                }
                if (dd.join('x') !== w) out.push({ t: dd.join('x'), w: dd.join('x'), k: 'dim', p: p, z: z, g: g, x: 1 });
              }
            }
            p++;
          }
        }
        if (unite && primo >= 0) {
          var tutto = sotto.join('');
          var ru = radice(L, tutto);
          if (opz.indice) out.push({ t: ru, w: tutto, k: 'par', p: out[primo].p, z: out[primo].z, g: g, x: 1 });
          else out[primo].u = { t: ru, n: sotto.length };
        }
      }
    }
    return out;
  }

  /* ------------------------------------------------------------------ */
  /* Da qui in giu' solo il browser: caricamento dell'indice e domanda.  */
  /* ------------------------------------------------------------------ */

  var B36 = '0123456789abcdefghijklmnopqrstuvwxyz';

  /* "3fJ1aK..." -> {idx: punteggio}: delta in base 36 + lettera A-Y (1-25). */
  function leggiElenco(str, dest, fattore) {
    var i = 0, acc = 0, num = 0;
    for (var c = 0; c < str.length; c++) {
      var ch = str.charCodeAt(c);
      if (ch >= 65 && ch <= 90) {
        acc += num;
        var s = (ch - 64) * fattore;
        if (!(dest[acc] >= s)) dest[acc] = s;
        num = 0;
        i++;
      } else {
        num = num * 36 + (ch <= 57 ? ch - 48 : ch - 87);
      }
    }
    return i;
  }

  var stato = { lingua: null, url: null, man: null, pMan: null, file: {}, attr: null, pAttr: null, h: {} };

  function baseUrl() { return (stato.url || '').split('?')[0].replace(/[^\/]+$/, ''); }
  function prendi(nome) {
    var u = baseUrl() + nome + '?v=' + encodeURIComponent((stato.man && stato.man.v) || '0');
    if (!stato.file[u]) {
      stato.file[u] = fetch(u, { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('mx ' + r.status);
        return r.json();
      }).catch(function (e) { delete stato.file[u]; throw e; });
    }
    return stato.file[u];
  }

  function avvia(lingua, url) {
    if (stato.pMan && stato.lingua === lingua) return stato.pMan;
    stato.lingua = lingua; stato.url = url;
    stato.pMan = fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('mx ' + r.status);
      return r.json();
    }).then(function (m) {
      stato.man = m;
      m.marcheSet = {};
      (m.mar || []).forEach(function (t) { m.marcheSet[t] = 1; });
      return m;
    }).catch(function (e) { stato.pMan = null; throw e; });
    return stato.pMan;
  }

  function pronto() {
    if (stato.pMan) return stato.pMan;
    var L = root.__AMES_LINGUA || 'it';
    var u = root.__AMES_MX_URL;
    if (!u) return Promise.reject(new Error('mx: indice non dichiarato'));
    return avvia(L, u);
  }

  function chiaveFile(t) {
    var f = stato.man.f;
    if (t.charAt(0) === '@') return f['@c'];
    var k3 = t.slice(0, 3);
    if (f[k3] != null) return f[k3];
    return f[t.slice(0, 2)];
  }
  function nomeFile(n) { return 'ames-mx-' + stato.lingua + '-' + ('00' + n).slice(-3) + '.json'; }

  /* Distanza di modifica con lo scambio di due lettere vicine contato come uno
     ("dewlat" -> "dewalt"). Si ferma appena supera max. */
  function distanza(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) { d[i] = [i]; }
    for (j = 0; j <= b.length; j++) d[0][j] = j;
    for (i = 1; i <= a.length; i++) {
      var minimo = max + 1;
      for (j = 1; j <= b.length; j++) {
        var costo = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        var v = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + costo);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) v = Math.min(v, d[i - 2][j - 2] + 1);
        d[i][j] = v;
        if (v < minimo) minimo = v;
      }
      if (minimo > max) return max + 1;
    }
    return d[a.length][b.length];
  }

  /* Prodotti di una parola: esatta, poi (se serve) per prefisso e con un refuso.
     Restituisce {mappa: {idx: punteggio}, modo: 'esatta'|'prefisso'|'simile'|null}. */
  function parola(t, opz) {
    var n = chiaveFile(t);
    if (n == null) return Promise.resolve({ mappa: {}, modo: null, chiavi: [] });
    return prendi(nomeFile(n)).then(function (sh) {
      var mappa = {}, modo = null, chiavi = [];
      if (sh[t]) { leggiElenco(sh[t], mappa, 1); modo = 'esatta'; chiavi.push(t); }
      var vuoi = opz.prefisso || !modo;
      if (vuoi && t.length >= 3 && t.charAt(0) !== '@') {
        var cand = [];
        for (var k in sh) if (k !== t && k.indexOf(t) === 0) cand.push(k);
        cand.sort(function (a, b) { return sh[b].length - sh[a].length; });
        cand.slice(0, 40).forEach(function (k) { leggiElenco(sh[k], mappa, modo ? 0.8 : 0.85); chiavi.push(k); });
        if (cand.length && !modo) modo = 'prefisso';
      }
      if (!modo && t.length >= 5 && /^[a-z]+$/.test(t)) {
        var max = t.length >= 8 ? 2 : 1, simili = [];
        for (var k2 in sh) {
          if (Math.abs(k2.length - t.length) <= max && distanza(t, k2, max) <= max) simili.push(k2);
        }
        simili.sort(function (a, b) { return sh[b].length - sh[a].length; });
        simili.slice(0, 12).forEach(function (k) { leggiElenco(sh[k], mappa, 0.7); chiavi.push(k); });
        if (simili.length) modo = 'simile';
      }
      return { mappa: mappa, modo: modo, chiavi: chiavi };
    }).catch(function () { return { mappa: {}, modo: null, chiavi: [] }; });
  }

  /* --- La domanda ---------------------------------------------------- */

  function frase(L, s) { return tokenizza(L, s, { domanda: true }).map(function (x) { return x.t; }); }

  /* Sinonimi e scorciatoie d'intento dall'indice L1 (ames-l1-<lingua>.json):
     stesso file e stessa fonte della tendina (md_ingest/ricerca/sinonimi_fonte.json). */
  function sinonimi() {
    var I = root.AMES_IDX;
    if (!I || !I.caricaL1) return Promise.resolve(null);
    return I.caricaL1().then(function () { return (I.l1 && I.l1() && I.l1().syn) || null; }).catch(function () { return null; });
  }

  function contiene(toks, seq) {
    if (!seq.length) return -1;
    outer: for (var i = 0; i + seq.length <= toks.length; i++) {
      for (var j = 0; j < seq.length; j++) if (toks[i + j].t !== seq[j]) continue outer;
      return i;
    }
    return -1;
  }

  /* Concetti della domanda: ognuno e' un elenco di alternative, ogni
     alternativa un elenco di radici. Tipi: testa (l'oggetto), marca, misura,
     modello, intento, altro. */
  function concetti(L, q, syn, man) {
    var toks = tokenizza(L, q, { domanda: true });
    var nota = null;
    // sostituzioni: "flex" -> "smerigliatrice angolare" (solo se la domanda e' quella)
    if (syn && syn.sostituzioni) {
      var qn = toks.map(function (x) { return x.w; }).join(' ');
      Object.keys(syn.sostituzioni).forEach(function (k) {
        var kn = tokenizza(L, k, { domanda: true }).map(function (x) { return x.w; }).join(' ');
        if (!kn) return;
        var sole = (syn.sole || []).indexOf(k) >= 0;
        var pos = (' ' + qn + ' ').indexOf(' ' + kn + ' ');
        if (pos < 0) return;
        if (sole && qn !== kn) return;
        qn = (' ' + qn + ' ').replace(' ' + kn + ' ', ' ' + syn.sostituzioni[k] + ' ').trim();
        nota = { da: k, a: syn.sostituzioni[k] };
      });
      if (nota) toks = tokenizza(L, qn, { domanda: true });
    }
    // parole generiche: via, se resta altro
    var gq = GENERICI_Q[L] || {}, generico = false;
    var resto = toks.filter(function (x) { return !gq[x.w]; });
    if (resto.length && resto.length < toks.length) { toks = resto; generico = true; }
    // un mestiere ("attrezzatura idraulico"): lo sa fare meglio la collezione del mestiere
    var prof = man.prof || {};
    var mestiere = toks.some(function (x) { return x.k === 'par' && (prof[x.t] === 1 || (generico && prof[x.t] === 0)); });
    // un verbo all'infinito in testa alla frase
    var verbo = false;
    if (L === 'it') {
      var crude = base(q).split(/[^a-z]+/).filter(Boolean);
      for (var vi = 0; vi < crude.length && crude.length > 1; vi++) {
        var vw = crude[vi];
        if (vw.length >= 5 && /(are|ere|ire)$/.test(vw) && !NON_VERBI[vw] && (vi === 0 || ATTACCHI[crude[vi - 1]])) { verbo = vw; break; }
      }
    }
    var usati = {}, cc = [];
    // equivalenze: gruppi di frasi che vogliono dire la stessa cosa. Prima le
    // frasi piu' lunghe ("casco da cantiere" prima di "casco"), ogni gruppo una volta.
    var gruppi = ((syn && syn.equivalenze) || []).concat((man.syn && man.syn.equivalenze) || []);
    var frasi = [];
    gruppi.forEach(function (gr, gi) {
      var seqs = gr.map(function (f) { return frase(L, f); }).filter(function (x) { return x.length; });
      seqs.forEach(function (sq) { frasi.push({ sq: sq, g: gi, seqs: seqs }); });
    });
    frasi.sort(function (a, b) { return b.sq.length - a.sq.length; });
    var gruppiUsati = {};
    frasi.forEach(function (fr) {
      if (gruppiUsati[fr.g]) return;
      var at = contiene(toks, fr.sq);
      if (at < 0) return;
      for (var b = at; b < at + fr.sq.length; b++) if (usati[b]) return;
      for (var c = at; c < at + fr.sq.length; c++) usati[c] = 1;
      gruppiUsati[fr.g] = 1;
      var tutteMisure = true;
      for (var d = at; d < at + fr.sq.length; d++) if (toks[d].k === 'par') tutteMisure = false;
      cc.push({ alt: fr.seqs, da: at, tipo: null, k: fr.sq.length === 1 ? toks[at].k : (tutteMisure ? 'mis' : 'par'), w: toks[at].w, propria: fr.seqs.findIndex(function (sq) { return sq.length === 1 && sq[0] === toks[at].t; }) });
    });
    // intenti: "svuotare cantina allagata" -> categorie
    var intento = null;
    if (syn && syn.intenti) {
      var testo = ' ' + toks.map(function (x) { return x.w; }).join(' ') + ' ';
      for (var ii = 0; ii < syn.intenti.length && !intento; ii++) {
        var it = syn.intenti[ii];
        for (var pp = 0; pp < (it.parole || []).length; pp++) {
          var pn = ' ' + tokenizza(L, it.parole[pp], { domanda: true }).map(function (x) { return x.w; }).join(' ') + ' ';
          if (pn.trim() && testo.indexOf(pn) >= 0) { intento = it; break; }
        }
      }
    }
    // codice scritto con trattini, punti o barre ("1.516-330.0", "FMHT0-74714"):
    // vale come codice unito, come lo SKU nell'indice
    var crudo = base(q).trim();
    if (!/\s/.test(crudo) && /\d/.test(crudo) && /[-.\/]/.test(crudo) && toks.length > 1) {
      var unito = crudo.replace(/[^a-z0-9]/g, '');
      if (unito.length >= 5) {
        cc.push({ alt: [[unito], toks.map(function (x) { return x.t; })], da: 0, tipo: null, k: 'cod', w: unito });
        toks.forEach(function (x, i) { usati[i] = 1; });
      }
    }
    toks.forEach(function (x, i) {
      if (usati[i]) return;
      if (verbo && x.w === verbo && intento) return;   // "pulire il piazzale": decide l'intento
      var alt = [[x.t]];
      if (x.u) alt.push([x.u.t]);
      // potenza: 5 kW = 5000 W
      var mk = /^(\d+(?:\.\d+)?)(kw|w)$/.exec(x.t);
      if (mk) {
        var v = parseFloat(mk[1]);
        if (mk[2] === 'kw') alt.push([String(Math.round(v * 1000)) + 'w']);
        else if (v >= 1000) alt.push([String(v / 1000) + 'kw']);
      }
      cc.push({ alt: alt, da: i, tipo: null, k: x.k, w: x.w });
    });
    cc.sort(function (a, b) { return a.da - b.da; });
    // tipo di ogni concetto
    var testa = null;
    cc.forEach(function (c) {
      var una = c.alt.length === 1 && c.alt[0].length === 1 ? c.alt[0][0] : (c.w && c.k === 'par' ? radice(L, c.w) : null);
      if (c.k === 'num' && c.w && c.w.length >= 4 && c.w.indexOf('.') < 0) c.tipo = 'modello';   // "makita 9031"
      else if (c.k === 'mis' || c.k === 'dim' || c.k === 'num' || c.k === 'fra') c.tipo = 'misura';
      else if (c.k === 'mod' || c.k === 'cod') c.tipo = 'modello';
      else if (una && man.marcheSet[una]) c.tipo = 'marca';
      else if (!testa) { c.tipo = 'testa'; testa = c; }
      else c.tipo = 'altro';
    });
    if (intento && intento.categorie && intento.categorie.length) {
      var ic = { alt: intento.categorie.map(function (h) { return ['@c:' + h]; }), tipo: 'intento', etichetta: intento.etichetta };
      cc.push(ic);
    }
    return { cc: cc, nota: nota, intento: intento, mestiere: mestiere, verbo: verbo };
  }

  var PESO = { testa: 3, marca: 1.5, misura: 1.2, modello: 2, intento: 3, altro: 1 };
  var MANCA = { testa: 6, marca: 12, misura: 10, modello: 8, intento: 0, altro: 8 };

  /* La domanda vera e propria. opz: {prefisso: true mentre si scrive,
     limite}. Restituisce {ris: [{i, s, ok, n}], ok: quanti hanno l'oggetto,
     tot, concetti, nota, intento}. */
  function cerca(q, opz) {
    opz = opz || {};
    return Promise.all([pronto(), sinonimi(), attr().catch(function () { return null; })]).then(function (v) {
      var man = v[0], syn = v[1], L = stato.lingua;
      var an = concetti(L, q, syn, man);
      var cc = an.cc;
      if (!cc.length) return { ris: [], ok: 0, tot: 0, concetti: cc, nota: an.nota };
      // mestieri e frasi col verbo: meglio la ricerca del negozio, che legge anche
      // le descrizioni, e le scorciatoie della tendina (collezione del mestiere)
      if (an.mestiere || (an.verbo && !an.intento)) {
        return { ris: [], ok: 0, tot: 0, concetti: cc, nota: an.nota, mestiere: an.mestiere, verbo: an.verbo, cede: true };
      }
      var ultimo = cc.filter(function (c) { return c.da != null; }).pop();
      var richieste = [];
      cc.forEach(function (c) {
        c.mappe = c.alt.map(function (a) {
          return Promise.all(a.map(function (t) {
            return parola(t, { prefisso: !!opz.prefisso && c === ultimo && a.length === 1 });
          }));
        });
        richieste.push(Promise.all(c.mappe).then(function (m) { c.mappe = m; }));
      });
      return Promise.all(richieste).then(function () {
        var tot = {}, testaC = null, conta = 0;
        // un marchio scritto male ("dewlat") arriva qui come oggetto: se tutte le
        // parole trovate sono marchi, e' un marchio
        cc.forEach(function (c) {
          if (c.tipo !== 'testa' || c.alt.length !== 1 || c.alt[0].length !== 1) return;
          var ch = c.mappe[0][0].chiavi;
          if (ch.length && ch.every(function (k) { return man.marcheSet[k]; })) c.tipo = 'marca';
        });
        cc.forEach(function (c) { if (c.tipo === 'testa') testaC = c; });
        // codice trovato intero: i pezzi ("fmht0", "330") non servono piu' e farebbero rumore
        cc.forEach(function (c) {
          if (c.k === 'cod' && c.alt.length > 1 && c.mappe[0].length === 1 && c.mappe[0][0].modo === 'esatta') {
            c.alt = [c.alt[0]]; c.mappe = [c.mappe[0]];
          }
        });
        // l'intento fa da oggetto quando la domanda e' tutta discorso
        var intentoC = cc.filter(function (c) { return c.tipo === 'intento'; })[0];
        cc.forEach(function (c) {
          c.sc = {};
          c.sc0 = null;
          c.trovato = false;
          c.mappe.forEach(function (lista) {
            if (!lista.length) return;
            if (lista.some(function (r) { return r.modo; })) c.trovato = true;
            if (lista.length === 1) {
              var m = lista[0].mappa;
              for (var i in m) if (!(c.sc[i] >= m[i])) c.sc[i] = m[i];
              return;
            }
            // alternativa di piu' parole: tutte presenti = media; in parte = meta' della media
            var unione = {};
            lista.forEach(function (r) { for (var i in r.mappa) unione[i] = 1; });
            for (var j in unione) {
              var somma = 0, n = 0;
              lista.forEach(function (r) { if (r.mappa[j]) { somma += r.mappa[j]; n++; } });
              var s = n === lista.length ? somma / n : 0.4 * somma / lista.length;
              if (!(c.sc[j] >= s)) c.sc[j] = s;
            }
          });
          if (c.propria >= 0 && c.mappe[c.propria] && c.mappe[c.propria].length === 1) c.sc0 = c.mappe[c.propria][0].mappa;
          for (var k in c.sc) tot[k] = 1;
        });
        // concetti che non trovano niente nell'indice (parole che nessun titolo usa)
        // non devono affondare tutto: si ignorano, tranne la testa
        var attivi = cc.filter(function (c) { return c.trovato; });
        var testaOk = testaC && testaC.trovato;
        if (an.verbo && intentoC && intentoC.trovato) { if (testaC) testaC.tipo = 'altro'; testaC = intentoC; }
        else if (!testaOk && intentoC && intentoC.trovato) testaC = intentoC;
        else if (!testaOk) testaC = attivi.filter(function (c) { return c.tipo === 'altro'; })[0] || null;
        var senza = {};
        (man.noimg || []).forEach(function (i) { senza[i] = 1; });
        var codiciQ = attivi.filter(function (c) { return c.tipo === 'modello'; });
        var ris = [];
        for (var id in tot) {
          var s = 0, n = 0, ok = false, own = false;
          attivi.forEach(function (c) {
            var v = c.sc[id] || 0;
            if (v >= 5) n++;
            if (v) s += PESO[c.tipo] * v;
            else s -= (MANCA[c.tipo] || 0) * PESO[c.tipo];
            if (c === testaC && v >= 9) ok = true;
            // il termine cercato nel titolo (22-25), non solo nella descrizione (10-12)
            if (c === testaC && c.sc0 && (c.sc0[id] || 0) >= 20) own = true;
            if (c.tipo === 'intento' && v && testaC !== c) s += 10;
          });
          if (!testaC) ok = codiciQ.length ? codiciQ.some(function (c) { return (c.sc[id] || 0) >= 9; }) : n > 0;
          if (ok) conta++;
          if (senza[id]) s -= 4;
          ris.push({ i: +id, s: s, ok: ok, n: n, own: own });
        }
        // Quando decide l'intento ("riscaldare un capannone") le categorie contengono
        // anche ricambi e accessori: prima le macchine, poi il resto.
        if (testaC && testaC.tipo === 'intento' && stato.attr) {
          ris.forEach(function (r) { if (accessorio(r.i)) r.s -= 20; });
        }
        // Categoria prevalente: fra chi ha l'oggetto, le categorie con piu' prodotti
        // vengono prima ("trapano": avvitatori e a percussione prima dei trapani a colonna).
        if (stato.attr && conta) {
          var perTipo = {}, max = 0;
          ris.forEach(function (r) {
            if (!r.ok) return;
            var t = tipoDi(r.i);
            perTipo[t] = (perTipo[t] || 0) + 1;
            if (perTipo[t] > max) max = perTipo[t];
          });
          ris.forEach(function (r) { if (r.ok) r.s += 12 * Math.sqrt(perTipo[tipoDi(r.i)] / max); });
        }
        // prima chi ha l'oggetto, poi chi ha piu' parole della domanda, poi il punteggio
        ris.sort(function (a, b) {
          if (a.ok !== b.ok) return a.ok ? -1 : 1;
          if (a.n !== b.n) return b.n - a.n;
          if (a.own !== b.own) return a.own ? -1 : 1;
          if (b.s !== a.s) return b.s - a.s;
          return a.i - b.i;
        });
        // codice trovato e pochi risultati: dopo il prodotto, i fratelli (stessa
        // categoria e stesso marchio; l'indice e' in ordine di titolo, quindi i
        // vicini sono i modelli accanto: DCH172N -> gli altri tassellatori DeWalt)
        var codC = cc.filter(function (c) { return c.tipo === 'modello' || c.k === 'cod'; });
        // domanda fatta solo di codici: i pezzi di codice che combaciano a meta' sono rumore
        if (codC.length && codC.length === attivi.length && conta) ris = ris.filter(function (r) { return r.ok; });
        if (stato.attr && codC.length && ris.length && conta < 8) {
          var primo = ris[0], visti = {};
          ris.forEach(function (r) { visti[r.i] = 1; });
          if (codC.some(function (c) { return c.sc[primo.i] >= 9; })) {
            var tt = tipoDi(primo.i), mm = marcaDi(primo.i), vicini = [];
            for (var d = 1; d < 60 && vicini.length < 12; d++) {
              [primo.i - d, primo.i + d].forEach(function (j) {
                if (j < 0 || j >= man.n || visti[j] || vicini.length >= 12) return;
                if (tipoDi(j) === tt && marcaDi(j) === mm) { vicini.push({ i: j, s: primo.s - 50 - d, ok: false, n: 0, f: 1 }); visti[j] = 1; }
              });
            }
            var okR = ris.filter(function (r) { return r.ok; }), noR = ris.filter(function (r) { return !r.ok; });
            ris = okR.concat(vicini, noR);
          }
        }
        // solo marchio ("makita"): un po' di tutto il marchio, non cento punte di fila
        var soloMarca = !testaC && attivi.length > 0 && attivi.every(function (c) { return c.tipo === 'marca'; });
        if (opz.varia !== false) ris = varia(ris, 600, soloMarca);
        return { ris: ris, ok: conta, tot: ris.length, concetti: cc, nota: an.nota, intento: an.intento, soloMarca: soloMarca };
      });
    });
  }

  /* --- Categoria e marchio di ogni prodotto -------------------------- */

  function attr() {
    if (stato.pAttr) return stato.pAttr;
    stato.pAttr = pronto().then(function () { return prendi('ames-mx-a.json'); }).then(function (a) {
      stato.attr = a;
      return a;
    }).catch(function (e) { stato.pAttr = null; throw e; });
    return stato.pAttr;
  }
  function cercaTratto(tratti, i) {
    // tratti = [inizio0, valore0, inizio1, valore1, ...] in ordine di inizio
    var lo = 0, hi = tratti.length / 2 - 1, r = 0;
    while (lo <= hi) {
      var mid = (lo + hi) >> 1;
      if (tratti[mid * 2] <= i) { r = mid; lo = mid + 1; } else hi = mid - 1;
    }
    return tratti[r * 2 + 1];
  }
  function tipoDi(i) { return stato.attr ? cercaTratto(stato.attr.rt, i) : -1; }
  /* Accessorio, ricambio o consumabile (prima parola del titolo): bit per prodotto in base64. */
  function accessorio(i) {
    var a = stato.attr;
    if (!a || !a.acc) return false;
    if (!a.accB) {
      var bin = (typeof atob === 'function') ? atob(a.acc) : Buffer.from(a.acc, 'base64').toString('binary');
      a.accB = new Uint8Array(bin.length);
      for (var k = 0; k < bin.length; k++) a.accB[k] = bin.charCodeAt(k);
    }
    return !!(a.accB[i >> 3] & (1 << (i & 7)));
  }
  function marcaDi(i) { return stato.attr ? cercaTratto(stato.attr.rv, i) : -1; }

  /* A parita' di grado, non dieci prodotti di fila dello stesso marchio: chi
     cerca "trapano" vede Milwaukee, Makita, DeWalt, Stanley. La categoria no:
     quella la decide la categoria prevalente (gruppi elettrogeni per "generatore"). */
  function varia(ris, quanti, perCategoria) {
    if (!stato.attr) return ris;
    if (perCategoria) return giroCategorie(ris);
    quanti = quanti || 600;
    var testa = ris.slice(0, quanti), resto = ris.slice(quanti);
    var gruppi = [], g = null, vm = {};
    testa.forEach(function (r) {
      if (!g || g.ok !== r.ok || g.n !== r.n || g.own !== r.own) { g = { ok: r.ok, n: r.n, own: r.own, v: [] }; gruppi.push(g); vm = {}; }
      var m = marcaDi(r.i);
      var gm = vm[m] || 0;
      vm[m] = gm + 1;
      g.v.push({ r: r, s: r.s - Math.min(gm, 5) * 1.5 });
    });
    var out = [];
    gruppi.forEach(function (gr) {
      gr.v.sort(function (a, b) { return b.s - a.s || a.r.i - b.r.i; });
      gr.v.forEach(function (x) { out.push(x.r); });
    });
    return out.concat(resto);
  }

  /* Solo marchio: un prodotto per categoria a giro, prima le categorie piu' ricche. */
  function giroCategorie(ris) {
    var ok = ris.filter(function (r) { return r.ok; }), altri = ris.filter(function (r) { return !r.ok; });
    var per = {}, ordine = [];
    ok.forEach(function (r) {
      var t = tipoDi(r.i);
      if (!per[t]) { per[t] = []; ordine.push(t); }
      per[t].push(r);
    });
    ordine.forEach(function (t) {
      per[t].sort(function (a, b) { return (accessorio(a.i) ? 1 : 0) - (accessorio(b.i) ? 1 : 0) || b.s - a.s || a.i - b.i; });
      per[t].macchine = per[t].filter(function (r) { return !accessorio(r.i); }).length;
    });
    // prima le macchine e gli attrezzi, poi accessori, ricambi e consumabili
    var RX_ACC = /^(accessori|ricambi|punte|dischi|lame|frese|inserti|batterie|caricabatterie|filtri|abrasivi|nastri|carta|spazzole|consumabili|lubrificanti|detergenti|sacchetti|cartucce|ugelli|elettrodi|viti|tasselli|bulloni)/i;
    var acc = function (t) { return RX_ACC.test((stato.attr.tipi || [])[t] || '') ? 1 : 0; };
    ordine.sort(function (a, b) { return acc(a) - acc(b) || (per[a].macchine ? 0 : 1) - (per[b].macchine ? 0 : 1) || per[b].macchine - per[a].macchine || per[b].length - per[a].length; });
    var out = [], giro = 0, presi = true;
    while (presi) {
      presi = false;
      for (var k = 0; k < ordine.length; k++) {
        var l = per[ordine[k]];
        if (l.length > giro) { out.push(l[giro]); presi = true; }
      }
      giro++;
    }
    return out.concat(altri);
  }

  /* --- Handle dei prodotti ------------------------------------------- */

  function handles(idx) {
    return pronto().then(function (man) {
      var per = man.hf || 512, servono = {};
      idx.forEach(function (i) { servono[Math.floor(i / per)] = 1; });
      return Promise.all(Object.keys(servono).map(function (f) {
        return prendi('ames-mx-h-' + ('00' + f).slice(-3) + '.json').then(function (a) { stato.h[f] = a; });
      })).then(function () {
        return idx.map(function (i) {
          var a = stato.h[Math.floor(i / per)];
          return a ? a[i % per] : null;
        });
      });
    });
  }

  root.AMES_MX = {
    tokenizza: tokenizza, radice: radice, prepara: prepara, base: base, genere: genere,
    GENERICI: GENERICI, CONFEZIONI: CONFEZIONI, VUOTE: VUOTE,
    avvia: avvia, pronto: pronto, cerca: cerca, attr: attr, tipoDi: tipoDi, marcaDi: marcaDi, accessorio: accessorio,
    varia: varia, handles: handles, leggiElenco: leggiElenco,
    manifesto: function () { return stato.man; }, lingua: function () { return stato.lingua; }
  };
})(typeof window !== 'undefined' ? window : globalThis);

if (typeof module !== 'undefined' && module.exports) module.exports = globalThis.AMES_MX;
